module.exports = __webpack_public_path__ + "img/invite-icon .146c326b.png";